import React, { Component } from 'react'
import {
  Router,
  Route,
  Switch
} from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import intl from 'react-intl-universal'
import * as mobx from 'mobx'
import { Provider } from 'mobx-react'
import { onSnapshot } from 'mobx-state-tree'
import shortid from 'shortid'

import prevent_body_scroll from './api/prevent_body_scroll'

// Stores
import store from './stores'

import { NotificationContainer, NotificationManager } from 'react-notifications'

import ScrollToTop from './components/ScrollToTop'

// Pages
import ErrorsHandler from './components/ErrorsHandler'
import HomePage from './containers/HomePage'
import NotFoundRoute from './containers/NotFoundRoute'
import ResultsPage from './containers/ResultsPage'
import CategoryPage from './containers/CategoryPage'
import ExperiencePage from './containers/ExperiencePage'
import CreateExperiencePage from './containers/CreateExperiencePage'
import BookExperiencePage from './containers/BookExperiencePage'
import RateExperiencePage from './containers/RateExperiencePage'
import ProfileByIdPage from './containers/ProfileByIdPage'
import ProfilePage from './containers/ProfilePage'
import ProfileNotificationsPage from './containers/ProfileNotificationsPage'
import ProfileMyExperiencesPage from './containers/ProfileMyExperiencesPage'
import ProfileMyWishlistPage from './containers/ProfileMyWishlistPage'
import ProfileMyBookingsPage from './containers/ProfileMyBookingsPage'
import ProfileSettingsPage from './containers/ProfileSettingsPage'
import SelectModal from './containers/SelectModal'
import LoginSuccessPage from './containers/LoginSuccessPage'
import LoginFailedPage from './containers/LoginFailedPage'
import ResetPasswordPage from './containers/ResetPasswordPage'
import ConfirmPage from './containers/ConfirmPage'

import InfoPage from './containers/InfoPage'
import page_help from './containers/page_help'
import page_uber from './containers/page_uber-uns'
import page_so from './containers/page_so-funktioniert-funoro'
import page_anmelden from './containers/page_anmelden'
import page_karriere from './containers/page_karriere'
import page_vertrauen from './containers/page_vertrauen'
import page_agbs from './containers/page_agbs'
import page_steuer from './containers/page_steuer'
import page_nutzungsbedingungen from './containers/page_nutzungsbedingungen'

// import 'react-router-modal/css/react-router-modal.css'

// In strict mode, it is not allowed to change any state outside of an `action`
mobx.useStrict(true)
// Create React Router Browser History
const history = createBrowserHistory()

const routes = [
  {
    path: '',
    component: HomePage
  },
  {
    path: 'search',
    component: ResultsPage
  },
  {
    path: 'profile',
    component: ProfilePage
  },
  {
    path: 'notifications',
    component: ProfileNotificationsPage
  },
  {
    path: 'my-experiences',
    component: ProfileMyExperiencesPage
  },
  {
    path: 'my-wishlist',
    component: ProfileMyWishlistPage
  },
  {
    path: 'my-bookings',
    component: ProfileMyBookingsPage
  },
  {
    path: 'settings',
    component: ProfileSettingsPage
  },
  {
    path: 'LoginSuccessPage',
    component: LoginSuccessPage
  },
  {
    path: 'LoginFailedPage',
    component: LoginFailedPage
  },
  {
    path: 'ResetPassword',
    component: ResetPasswordPage
  },
  {
    path: 'confirm',
    component: ConfirmPage
  },
  {
    path: 'create-experience',
    component: CreateExperiencePage
  },
  // Info pages
  {
    path: 'info-page',
    component: InfoPage
  },
  {
    path: 'help',
    component: page_help
  },
  {
    path: 'uber-uns',
    component: page_uber
  },
  {
    path: 'so-funktioniert-funoro',
    component: page_so
  },
  {
    path: 'anmelden',
    component: page_anmelden
  },
  {
    path: 'karriere',
    component: page_karriere
  },
  {
    path: 'vertrauen-and-sicherheit',
    component: page_vertrauen
  },
  {
    path: 'agbs',
    component: page_agbs
  },
  {
    path: 'steuer',
    component: page_steuer
  },
  {
    path: 'nutzungsbedingungen',
    component: page_nutzungsbedingungen
  },
]

// locale data
const locales = {
  'de': require('./locales/de.json'),
}

class App extends Component {
  state = {initDone: false}

  componentDidMount() {
    // prevent_body_scroll('js-modal-opened');
    this.loadLocales();
  }

  loadLocales() {
    // init method will load CLDR locale data according to currentLocale
    // react-intl-universal is singleton, so you should init it only once in your app
    intl.init({
      currentLocale: 'de', // TODO: determine locale here
      locales,
    })
      .then(() => {
        // After loading CLDR locale data, start to render
        this.setState({initDone: true});
      });
  }

  render () {
    return (
      this.state.initDone &&
      <Provider {...store}>
        <Router history={history}>
          <ErrorsHandler>
            <ScrollToTop>
              <div>
                <Switch>
                  {/* Define main routes */}
                  {routes.map((route, index) =>
                    <Route exact key={shortid.generate()} path={'/' + route.path} component={route.component} />
                  )}
                  {/* Dynamic routes */}
                  <Route exact path='/user/:id' component={ProfileByIdPage} />
                  <Route exact path='/experience/:id' component={ExperiencePage} />
                  <Route exact path='/experience/:experience_id/book/:event_id' component={BookExperiencePage} />
                  <Route exact path='/experience/:experience_id/rate/:event_id' component={RateExperiencePage} />
                  <Route exact path='/category/:id' component={CategoryPage} />
                  {/* Not found */}
                  <Route component={NotFoundRoute} />
                </Switch>

                <SelectModal />
                <NotificationContainer />
              </div>
            </ScrollToTop>
          </ErrorsHandler>
        </Router>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js